<template>
  <pre-login-layout>
    <template v-slot>
      <router-view />
    </template>
  </pre-login-layout>
</template>

<script>
import PreLoginLayout from '@layouts/PreLoginLayout.vue';
export default {
  components: {
    PreLoginLayout,
  },
};
</script>